import styles from "../styles/PopularActivity.module.scss";
export default function CreateActivitySection({
  dotSlider,
  activeSlide,
  changeSlide,
}: {
  dotSlider: number;
  activeSlide?: string;
  changeSlide: (currentPage: number) => void;
}) {
  return (
    <div
      className={`${styles.dot} ${activeSlide}`}
      onClick={() => changeSlide(dotSlider + 1)}
    ></div>
  );
}
